import React, { Component } from 'react';
import Trend from 'react-trend';

import getScoreClass from '../modules/scoreclass';

class ResultTrend extends Component {

  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  render() {
    if (this.props.resultHistory.length < 2) {
      return <span></span>;
    }
    const gradient = ['#ff0000', '#ffa500', '#ffff00', '#008000'];
    const data = this.props.resultHistory.map( result =>  parseInt(result.score, 10) || 0);

    return (
      <div className="pronounce-result-trend">
        <Trend
          data={data}
          autoDraw
          autoDrawDuration={500}
          autoDrawEasing="ease-in"
          smooth
          radius={6}
          strokeWidth={2}
          />
      </div>
    );
  }
}

export default ResultTrend;



// WEBPACK FOOTER //
// ./src/components/ResultTrend.js